module.exports = __webpack_public_path__ + "assets/img/empty.7bbaba0e.png";